"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 826 119"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    className: "logo_svg__logo-text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 29.403v49.311h30.711v10.408H.338V29.403H11.6m89.58 59.719H56.477V29.403h44.703v10.92H67.652v13.736h32.333v10.493H67.652v13.479h33.528v11.091m48.46.256h-11.688l-24.826-59.975h12.626l18.001 46.495 18.086-46.495h12.626L149.64 89.378m82.671-.256h-44.703V29.403h44.703v10.92h-33.527v13.736h32.333v10.493h-32.333v13.479h33.527v11.091m26.365-59.719v49.311h30.713v10.408h-41.974V29.403h11.261M484.651 39.641h-18.938V29.403h49.139v10.238h-18.939v49.481h-11.262V39.641m96.407 49.481h-13.395L550.26 69.159h-10.835v19.963h-11.261V29.318c9.47 0 18.938.085 28.408.085 14.077.086 21.499 9.47 21.499 19.793 0 8.19-3.754 16.465-15.1 18.769l18.087 20.39v.767zm-41.633-49.225v19.11h17.147c7.167 0 10.238-4.778 10.238-9.555s-3.157-9.555-10.238-9.555h-17.147zm95.041 37.963h-31.225l-5.118 11.262h-12.2l26.788-59.719h12.285l26.788 59.719h-12.285l-5.033-11.262zm-15.612-35.916-11.091 25.423h22.181l-11.09-25.423zm67.059 47.434h-11.687L649.4 29.403h12.626l18.001 46.495 18.086-46.495h12.626l-24.826 59.975m82.672-.256h-44.703V29.403h44.703v10.92h-33.527v13.736h32.333v10.493h-32.333v13.479h33.527v11.091m26.365-59.719v49.311h30.712v10.408h-41.974V29.403h11.262"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.064 59.323c0 32.523-26.365 58.888-58.888 58.888-32.524 0-58.889-26.365-58.889-58.888C.287 26.8 26.652.434 59.176.434c32.523 0 58.888 26.366 58.888 58.889",
    fill: "url(#logo_svg__a)",
    transform: "translate(320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.176 23.99c-17.421 0-31.544 14.123-31.544 31.544 0 2.047.177 3.268.177 3.268.216 1.494 1.627 2.717 3.137 2.717h56.46c1.509 0 2.921-1.223 3.137-2.717 0 0 .177-1.221.177-3.268 0-17.421-14.123-31.544-31.544-31.544",
    fill: "#FCEE21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.186 69.752c0 1.661-1.482 3.019-3.293 3.019h-83.709c-1.811 0-3.293-1.358-3.293-3.019 0-1.66 1.482-3.019 3.293-3.019h83.709c1.811 0 3.293 1.359 3.293 3.019m-12.35 11.527c0 1.661-1.482 3.019-3.294 3.019h-59.007c-1.812 0-3.294-1.358-3.294-3.019 0-1.66 1.482-3.019 3.294-3.019h59.007c1.812 0 3.294 1.359 3.294 3.019m-14.821 11.527c0 1.661-1.482 3.019-3.293 3.019h-29.367c-1.811 0-3.293-1.358-3.293-3.019 0-1.66 1.482-3.019 3.293-3.019h29.367c1.811 0 3.293 1.359 3.293 3.019",
    fill: "#FFF"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLogo);
var _default = exports["default"] = Memo;